/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages

        /****************
        **  Primary Navigation - mobile open/close, mobile toggle spin
        *****************/
        $( "#menu-primary-navigation li.menu-item-has-children > a" ).click(function(e){
          // show hide paragraph on button click
          e.preventDefault();
          var parentLI = $(this).closest('li.menu-item-has-children');
          var toggleClass = "show-sub-menu";
          var subMenu = $(this).next('ul.sub-menu');

          if($(subMenu).is(":visible")){
            $(parentLI).removeClass(toggleClass);
            $(subMenu).hide();
          } else{
            $(parentLI).addClass(toggleClass);
            $(subMenu).show();
          }
          return false;
        });

        $('#nav-wrapper').on('shown.bs.collapse', function () {
          $('body').addClass('primary-nav-engaged');
        });
        $('#nav-wrapper').on('show.bs.collapse', function () {
          $('body').addClass('primary-nav-engaging');
        });
        $('#nav-wrapper').on('hide.bs.collapse', function () {
          $('body').removeClass('primary-nav-engaged primary-nav-engaging');
        });

        $('.team-grid-block .team-content,.key-contacts-block .team-content').matchHeight({ byRow: false });
        $('.team-grid-block .team-content figure,.key-contacts-block .team-content figure').matchHeight();

        $('.news-block .news-block-row article.hentry a').matchHeight();
        $('.news-block .news-block-row article.hentry a p.category').matchHeight();
        $('.news-block .news-block-row article.hentry a h3').matchHeight();

        /****************
        **  SVG swap out with PNG on incompatible browsers
        *****************/
        if (!Modernizr.svg) {
          $('img[src*="svg"]').attr('src', function() {
            return $(this).attr('src').replace('.svg', '.png');
          });
        }

        /****************
        **  add styling to Form Upload fieilds
        *****************/
        $(":file").filestyle({
          btnClass: "btn-yellow",
          badge: true,
          input: false,
          text: "Choose file",
          htmlIcon: '<i class="fa-regular fa-file-arrow-up"></i> '
        });


        /****************
        **  CTA Sliders
        *****************/
        $(".cta-slider").each(function () {
          var slider = $(this);
          slider.slick({
            rows: 0,
            arrows: true,
            prevArrow: slider.find('.slick-arrows .prev'),
            nextArrow: slider.find('.slick-arrows .next'),
            dots: false,
            infinite: true,
            speed: 600,
            fade: true,
            cssEase: 'linear',
            autoplay: true,
            autoplaySpeed: 6500
          });
        });
        $(".cta-slider article.slick-slide").matchHeight();


        /****************
        **  practice areas/careers collapse/show
        *****************/
        $('.practice-areas-block .practice-area-category a.practice-area-toggle,.career-opportunities-block .career-opportunity a.career-opportunity-toggle').click(function(e){
          e.preventDefault();
          var clickChoice = $(this).attr("href").split("#")[1];

          if ($('.practice-area-category.'+clickChoice+' > ul,.career-opportunity.'+clickChoice+' > div.details').is(":visible")){
            $('.practice-area-category.'+clickChoice+' > ul,.career-opportunity.'+clickChoice+' > div.details').slideUp(125);
            $('.practice-area-category.'+clickChoice+',.career-opportunity.'+clickChoice).removeClass('active');
          } else{
            $('.practice-area-category.'+clickChoice+' > ul,.career-opportunity.'+clickChoice+' > div.details').slideDown(150);
            $('.practice-area-category.'+clickChoice+',.career-opportunity.'+clickChoice).addClass('active');
          }
          return false;
        });



      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // blog
    'blog': {
      init: function() {
        // JavaScript to be fired on the home page
        $('.news-items-row article.hentry a').matchHeight();
        $('.news-items-row article.hentry a p.category').matchHeight();
        $('.news-items-row article.hentry a h3').matchHeight();

      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // category archive
    'category': {
      init: function() {
        // JavaScript to be fired on the home page
        $('#menu-category-navigation .menu-latest').removeClass('active');
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // Tean page
    'our_team': {
      init: function() {
        // JavaScript to be fired on the home page
        $('.grid-attorneys .industry-filters li a').click(function(e){
          e.preventDefault();
          var attorneyChoice = $(this).attr("href").split("#")[1];
          $('.grid-attorneys .industry-filters li a').removeClass('active');
          $(this).addClass('active');
          $('.grid-attorneys .team-card').hide();
          $('.grid-attorneys .team-card.'+attorneyChoice).show();
          $('.grid-attorneys .team-type a.filter-reset').show(100);
          $('.grid-paralegals,.grid-staff').hide();
          return false;
        });
        $('.grid-attorneys .team-type a.filter-reset').click(function(e){
          e.preventDefault();
          $('.grid-attorneys .industry-filters li a').removeClass('active');
          $('.grid-attorneys .team-type a.filter-reset').hide();
          $('.grid-attorneys .team-card').show();
          $('.grid-paralegals,.grid-staff').show();
          return false;
        });
        $('.grid-attorneys .team-type a.filter-toggle').click(function(e){
          e.preventDefault();
          if ($('.grid-attorneys .industry-filters').is(":visible")){
            $('.grid-attorneys .industry-filters').slideUp(125);
            $(this).find('.fa-chevron-right').show();
            $(this).find('.fa-chevron-down').hide();
          } else{
            $('.grid-attorneys .industry-filters').slideDown(200);
            $(this).find('.fa-chevron-right').hide();
            $(this).find('.fa-chevron-down').show();
          }
          return false;
        });
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // Single Team page
    'single_team': {
      init: function() {
        // JavaScript to be fired on the home page
        $( "#breadcrumbs span.breadcrumb_last" ).before( "<span><a href='/our-team/'>Our Team</a></span> &nbsp;&raquo;&nbsp; " );
        $('#menu-primary-navigation li.menu-our-team').addClass('active');
        $('.team-widget a.staff-groups-toggle').click(function(e){
          e.preventDefault();
          if ($('.team-widget .staff-groups').is(":visible")){
            $('.team-widget .staff-groups').slideUp(225);
            $(this).find('.fa-circle-minus').hide();
            $(this).find('.fa-circle-plus').show();
          } else{
            $('.team-widget .staff-groups').slideDown(300);
            $(this).find('.fa-circle-minus').show();
            $(this).find('.fa-circle-plus').hide();
          }
          return false;
        });

        $('.publications .showall .toggler').click(function(e){
          e.preventDefault();
          if ($('.publication.additional').is(":visible")){
            $('.publication.additional').slideUp(225);
          } else{
            $('.publication.additional').slideDown(300);
          }
          return false;
        });
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },

    // Single Practice Area
    'single_practice_area': {
      init: function() {
        // JavaScript to be fired on the home page
        $( "#breadcrumbs span.breadcrumb_last" ).before( "<span><a href='/practice-areas/'>Practice Areas</a></span> &nbsp;&raquo;&nbsp; " );
        $('#menu-primary-navigation li.menu-practice-areas').addClass('active');
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // 404
    'error404': {
      init: function() {
        // JavaScript to be fired on the home page
        $('#menu-primary-navigation li.menu-news-insights').removeClass('active');
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
